import { IRoamingInternationalCountry } from "@nju/data-access-portal-dashboard";
import { IOffer } from "@nju/data-access-portal-offers";
import { OfferEU, OfferPromo, OfferStandard } from "../offers";
import {
  IButtonType,
  IFilteredOffer,
  IOfferType,
  IPackageType,
} from "../types";

interface IOfferProps {
  offerType: IOfferType | undefined;
  selectedCountry: IRoamingInternationalCountry;
  roamingOffers: IFilteredOffer;
  promoRoamingOffers: IFilteredOffer;
  selectedVoicePackage: IOffer | undefined;
  selectedDataPackage: IOffer | undefined;
  onSelectVoicePackage: (type: IButtonType, packageType: IPackageType) => void;
  onSelectDataPackage: (type: IButtonType, packageType: IPackageType) => void;
  onSetDefaultPackages: (packageType: IPackageType) => void;
  packageType: IPackageType;
  setPackageType: (packageType: IPackageType) => void;
}

export function Offer({
  onSetDefaultPackages,
  offerType,
  selectedCountry,
  roamingOffers,
  selectedDataPackage,
  selectedVoicePackage,
  onSelectDataPackage,
  onSelectVoicePackage,
  promoRoamingOffers,
  packageType,
  setPackageType,
}: IOfferProps) {
  const isOfferEu = offerType === "EU";
  const isStandardOffer = offerType === "EXOTIC" || offerType === "STANDARD";
  const isPromoOffer = offerType === "HT" || offerType === "BREXIT";

  if (isOfferEu) {
    return <OfferEU selectedCountry={selectedCountry} />;
  }

  if (selectedDataPackage || selectedVoicePackage) {
    if (isStandardOffer) {
      return (
        <OfferStandard
          onSelectDataPackage={onSelectDataPackage}
          onSelectVoicePackage={onSelectVoicePackage}
          roamingOffers={roamingOffers}
          selectedCountry={selectedCountry}
          selectedDataPackage={selectedDataPackage}
          selectedVoicePackage={selectedVoicePackage}
        />
      );
    }

    if (isPromoOffer) {
      return (
        <OfferPromo
          onSelectDataPackage={onSelectDataPackage}
          onSelectVoicePackage={onSelectVoicePackage}
          onSetDefaultPackages={onSetDefaultPackages}
          packageType={packageType}
          promoRoamingOffers={promoRoamingOffers}
          roamingOffers={roamingOffers}
          selectedCountry={selectedCountry}
          selectedDataPackage={selectedDataPackage}
          selectedVoicePackage={selectedVoicePackage}
          setPackageType={setPackageType}
        />
      );
    }
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
